import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Container from '@mui/material/Container'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'

export default function NotFound() {
    return (
        <Container maxWidth='sm'>
            <Box
                sx={{
                    minHeight: '100vh',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center'
                }}
            >
                <Stack spacing={3} alignItems='center' textAlign='center'>
                    <Typography
                        variant='h1'
                        fontWeight={700}
                        color='primary'
                    >
                        ٤٠٤
                    </Typography>

                    <Typography variant='h4' fontWeight={600}>
                        الصفحة غير موجودة
                    </Typography>

                    <Typography variant='body1' color='text.secondary'>
                        يبدو أن الصفحة التي تبحث عنها غير متوفرة أو تم نقلها إلى مكان آخر
                    </Typography>

                    <Button
                        component={Link}
                        href='/dashboard/'
                        variant='contained'
                        size='large'
                        sx={{boxShadow: 0}}
                    >
                        العودة إلى لوحة التحكم
                    </Button>
                </Stack>
            </Box>
        </Container>
    )
}